export enum TableDataSortType {
  NONE = '',
  ASC = 'asc',
  DESC = 'desc',
}
